import { Col, Row, Typography } from "antd";
import { useParams } from "react-router-dom";
import { useGetNewsDetails } from "./ServerSideStates";
import NewsDetailsCarousel from "./Components/Carousel";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";


const { Title, Paragraph } = Typography;

const NewsDetailsIndex = () => {
  const params = useParams();
  const newsId = params["newsId"];
  const newsDetails = useGetNewsDetails(newsId || "");
  const newsItemData = newsDetails.data?.data || null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (!newsItemData) return null;

  console.log("newsItemData", newsItemData);

  return (
    <Col span={24} className="!overflow-hidden bg-white">
      <StaticPageBanner
        title={newsItemData.title}
        description={newsItemData.shortDescription}
        date={new Date(newsItemData.insertDate)}
        category={newsItemData.category}
      />

      <Row justify="center" gutter={[16, 32]} className="px-4 md:px-8 xl:px-24 mt-4">
        <Helmet>
          <title>{newsItemData.category.type === 1 ? "Araç Haberleri" : "Gayrimenkul Haberleri"}</title>
        </Helmet>
        <Col xs={24}>
          <NewsDetailsCarousel newsDetails={newsDetails} />

        </Col>

        <Col xs={24}>
          <Typography className="text-justify">
            <div
              className="html-description text-[15px] leading-7 text-[#333] [&_>_*]:!px-0"
              dangerouslySetInnerHTML={{ __html: newsItemData.description }}
            />
          </Typography>
        </Col>
      </Row>
    </Col>
  );
};

export default NewsDetailsIndex;
